import { Box, Image } from "@chakra-ui/react";
import { getCountryFlagEmoji, getCountryFlagUrl } from "../../util/countryFlag";

/**
 * Renders a small flag for a country name (e.g. "United States" → US flag).
 */
export default function CountryFlag({
  country,
  size = 18,
  borderRadius = "3px",
  ...props
}) {
  if (!country) return null;

  const url = getCountryFlagUrl(country, 40);
  const emoji = getCountryFlagEmoji(country);

  if (url) {
    return (
      <Image
        src={url}
        alt=""
        aria-hidden
        w={`${size}px`}
        h={`${Math.round(size * 0.72)}px`}
        objectFit="cover"
        borderRadius={borderRadius}
        flexShrink={0}
        boxShadow="0 0 0 1px rgba(0,0,0,0.08)"
        {...props}
      />
    );
  }

  if (emoji) {
    return (
      <Box
        as="span"
        fontSize={`${size}px`}
        lineHeight={1}
        flexShrink={0}
        aria-hidden
        {...props}
      >
        {emoji}
      </Box>
    );
  }

  return null;
}
